// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"634":"847ee5ff","817":"4bd9b7e1"}[chunkId] + ".chunk.js";
};